import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: -1,
  rao: '',
}

export const ProveidorSlice = createSlice({
  name: 'proveidor',
  initialState,
  reducers: {
    setProveidor: (state, { payload }) => {
      const { id, rao } = payload
      return { ...state, id, rao }
    },

    clearProveidor: (state, { payload }) => {
      return { ...state, id: -1 }
    },
  },
})

export const { setProveidor, clearProveidor } = ProveidorSlice.actions

export default ProveidorSlice.reducer
